<template>
    <div>
        <textarea class="input" :style="styles" :name="name" title="" ref="area" :disabled="!!disabled" :placeholder="placeholder" v-model="newValue" @focus="$emit('focus')" @blur="$emit('blur')" @input="fitToContent()" v-on:change="fitToContent()"></textarea>
    </div>
</template>

<script>
import { Default } from '@/mixins/mixins';

export default {
    name: 'text-area',
    mixins: [
        Default
    ],
    props: {
        name: {},
        placeholder: {},
        value: {},
        disabled: {},
        minHeight: {
            type: String,
            default: '5em'
        }
    },
    data() {
        return {
            newValue: ''
        };
    },
    created() {
        this.newValue = this.value;
    },
    mounted() {
        this.$nextTick(() => {
            // Code that will run only after the entire view has been rendered
            this.fitToContent();
        });
    },
    computed: {
        styles() {
            return {
                'min-height': this.minHeight
            };
        }
    },
    watch: {
        value: function(newVal, oldVal) {
            if (newVal !== oldVal)
                this.newValue = newVal;

            this.fitToContent();
        },
        newValue: function(newVal, oldVal) {
            this.$emit('input', newVal);
            this.fitToContent();
        }
    },
    methods: {
        fitToContent: function() {
            if (this.disabled)
                return;

            const newScrollHeight = this.$refs.area.scrollHeight + 'px'; // +2 as a margin for the padding (gets rid of the scrollbar)

            if (newScrollHeight <= this.minHeight) {
                return;
            }

            this.$refs.area.style.minHeight = newScrollHeight;
            this.$refs.area.style.height = newScrollHeight;
        }
    }
};
</script>

<style lang="scss" scoped>
    @import "../../../assets/styles/customInput/input";

    .input {
        max-height: 20em;
        padding: .3em; // To match the <custom-input type="input"> centering, kinda offset to hide the scrollbars
    }
</style>
